import { apiBasic, apiGet } from "./requests";

export const getProducts = (query) => {
  let path = "products";
  return apiGet(path, query);
};

export const getCategories = (query) => {
  let path = "product-categories";
  return apiGet(path, query);
};

export const getCustomerCart = () => {
  let path = "get-customer-cart";
  return apiGet(path);
};

export const clearCustomerCart = () => {
  let path = "clear-customer-cart";
  return apiBasic({}, path, "delete");
};

export const addProductToCart = (payload) => {
  let path = "add-product-to-cart";
  return apiBasic(payload, path, "post");
};

export const removeProductFromCart = (payload) => {
  let path = "remove-product-from-cart";
  return apiBasic(payload, path);
};

export const updateCartProductQuantity = (payload) => {
  let path = "update-cart-product-quantity";
  return apiBasic(payload, path, "patch");
};

export const getProductInfo = (payload) => {
  let path = `get-product-info/${payload}`;
  return apiGet(path);
};

export const getProductBySlug = (urlSlug) => {
  let path = `get-product-info-by-slug/${urlSlug}`;
  return apiGet(path);
};

export const makeOrder = (payload) => {
  let path = "make-order";
  return apiBasic(payload, path);
};

export const getTrackCustomerOrder = (payload) => {
  let path = `track-customer-order/${payload}`;
  return apiGet(path);
};

export const getCustomerOrdersHistory = (payload) => {
  let path = "get-customer-ordrers-history";
  return apiBasic(payload, path);
};

export const payOrder = (payload) => {
  let path = "pay-order";
  return apiBasic(payload, path);
};

export const getProductPriceBySlug = (slug, selection) => apiGet(`get-product-price-by-slug/${encodeURIComponent(slug)}`, selection);

export const quoteCart = (payload) => apiBasic(payload, "quote-cart");

export const reconcileCart = local => apiBasic({local}, "reconcile-cart");

export const applyCartDiscountCode = (shoppingCartId, code) => apiBasic({code}, `shopping-cart/${encodeURIComponent(shoppingCartId)}/discount-code`);
export const removeCartDiscount = (shoppingCartId, discountId) => apiBasic({}, `shopping-cart/${encodeURIComponent(shoppingCartId)}/discount/${encodeURIComponent(discountId)}`, "delete");
